/**
 * StarlitTunes — Product Image Popup
 * Shows a "Listen / Watch" menu when clicking the product image
 * on the piano sheet music product page.
 * Single "Listen & Watch" button placed under the piano MP3 player.
 * Deployed via layout/theme.liquid
 */
(function () {
  'use strict';

  // ── Only run on the piano sheet music product page ──
  if (!window.location.pathname.includes('chapter-1-piano-sheet-music')) return;

  var PIANO_MP3 =
    'https://cdn.shopify.com/s/files/1/0808/0287/3568/files/the_peace_before_the_storm_piano.mp3?v=1782255954';
  var LYRIC_VIDEO_URL = 'https://www.youtube.com/watch?v=gaLkP2Xv8Vc';
  var ANIMATION_URL = 'https://www.youtube.com/watch?v=qedfxXjZjDw';
  var TRAILER_URL = 'https://www.youtube.com/watch?v=93wOwoKHyLI';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = [
    '#st-img-popup-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.85);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);display:flex;align-items:center;justify-content:center;opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s}',
    '#st-img-popup-overlay.active{opacity:1;visibility:visible}',

    '.st-img-popup{background:linear-gradient(145deg,#111118,#0a0a0f);border:1px solid rgba(201,164,74,.3);border-radius:16px;padding:32px;max-width:440px;width:90vw;position:relative;transform:scale(.92);transition:transform .3s;box-shadow:0 24px 64px rgba(0,0,0,.6),0 0 40px rgba(201,164,74,.1);max-height:90vh;overflow-y:auto}',
    '#st-img-popup-overlay.active .st-img-popup{transform:scale(1)}',

    '.st-img-popup__close{position:absolute;top:10px;right:14px;background:0 0;border:0;color:#666;font-size:28px;cursor:pointer;padding:4px 8px;line-height:1;transition:color .2s}',
    '.st-img-popup__close:hover{color:#fff}',

    ".st-img-popup__title{font-family:'Playfair Display',serif;color:#fff;font-size:22px;margin:0 0 6px;font-weight:700}",
    '.st-img-popup__sub{color:#777;font-size:13px;margin:0 0 22px}',

    '.st-img-popup__opts{display:flex;flex-direction:column;gap:10px}',

    '.st-img-opt{display:flex;align-items:center;gap:16px;padding:14px 18px;border-radius:12px;text-decoration:none!important;cursor:pointer;transition:all .25s;border:1px solid transparent}',

    '.st-img-opt--piano{background:rgba(201,164,74,.08);border-color:rgba(201,164,74,.2)}',
    '.st-img-opt--piano:hover{background:rgba(201,164,74,.18);border-color:rgba(201,164,74,.45);transform:translateY(-2px);box-shadow:0 8px 24px rgba(201,164,74,.12)}',

    '.st-img-opt--video{background:rgba(168,216,255,.08);border-color:rgba(168,216,255,.2)}',
    '.st-img-opt--video:hover{background:rgba(168,216,255,.18);border-color:rgba(168,216,255,.45);transform:translateY(-2px);box-shadow:0 8px 24px rgba(168,216,255,.12)}',

    '.st-img-opt--animation{background:rgba(255,140,105,.08);border-color:rgba(255,140,105,.2)}',
    '.st-img-opt--animation:hover{background:rgba(255,140,105,.18);border-color:rgba(255,140,105,.45);transform:translateY(-2px);box-shadow:0 8px 24px rgba(255,140,105,.12)}',

    '.st-img-opt--trailer{background:rgba(180,140,255,.08);border-color:rgba(180,140,255,.2)}',
    '.st-img-opt--trailer:hover{background:rgba(180,140,255,.18);border-color:rgba(180,140,255,.45);transform:translateY(-2px);box-shadow:0 8px 24px rgba(180,140,255,.12)}',

    '.st-img-opt__icon{font-size:28px;flex-shrink:0;line-height:1}',
    '.st-img-opt__txt{display:flex;flex-direction:column;gap:2px}',
    '.st-img-opt__txt strong{color:#fff;font-size:15px;font-weight:600}',
    '.st-img-opt__txt small{color:#888;font-size:12px}',

    '.st-img-popup__player{margin-top:14px;padding:14px;background:rgba(201,164,74,.06);border-radius:10px;border:1px solid rgba(201,164,74,.18);display:none}',
    '.st-img-popup__player.active{display:block}',
    '.st-img-popup__player audio{width:100%;height:40px}',
    '.st-img-popup__player p{color:#777;font-size:11px;text-align:center;margin:6px 0 0}',

    /* Play badge on the product image itself (desktop only) */
    '.st-play-badge{position:absolute;bottom:12px;right:12px;z-index:10;display:flex;align-items:center;gap:6px;background:rgba(0,0,0,.72);border:1px solid rgba(201,164,74,.45);border-radius:24px;padding:6px 14px 6px 10px;color:#fff;font-size:12px;font-weight:600;pointer-events:none;backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);transition:all .3s}',
    '.product-media-container:hover .st-play-badge{background:rgba(201,164,74,.25);border-color:rgba(201,164,74,.7)}',


    '@media(max-width:749px){.st-play-badge{display:none}}'
  ].join('\n');
  document.head.appendChild(css);

  // ── Build popup DOM ──
  var overlay = document.createElement('div');
  overlay.id = 'st-img-popup-overlay';
  overlay.innerHTML =
    '<div class="st-img-popup">' +
      '<button class="st-img-popup__close" aria-label="Close">&times;</button>' +
      '<h3 class="st-img-popup__title">\uD83C\uDFB5 Experience the Music</h3>' +
      '<p class="st-img-popup__sub">Choose how you\'d like to experience Chapter 1</p>' +
      '<div class="st-img-popup__opts">' +

        /* 1. Piano Arrangement */
        '<a href="#" class="st-img-opt st-img-opt--piano" id="st-opt-piano">' +
          '<span class="st-img-opt__icon">\uD83C\uDFB9</span>' +
          '<span class="st-img-opt__txt">' +
            '<strong>Listen to the Piano Arrangement</strong>' +
            '<small>Performed by Envatilea</small>' +
          '</span>' +
        '</a>' +

        /* 2. Lyric Video */
        '<a href="' + LYRIC_VIDEO_URL + '" target="_blank" rel="noopener" class="st-img-opt st-img-opt--video">' +
          '<span class="st-img-opt__icon">\uD83C\uDFAC</span>' +
          '<span class="st-img-opt__txt">' +
            '<strong>Watch the Lyric Video</strong>' +
            '<small>100,000+ views on YouTube</small>' +
          '</span>' +
        '</a>' +

        /* 3. Chapter 1 Animation */
        '<a href="' + ANIMATION_URL + '" target="_blank" rel="noopener" class="st-img-opt st-img-opt--animation">' +
          '<span class="st-img-opt__icon">\uD83C\uDFA8</span>' +
          '<span class="st-img-opt__txt">' +
            '<strong>Watch the Chapter 1 Animation</strong>' +
            '<small>The full animated story</small>' +
          '</span>' +
        '</a>' +

        /* 4. Trailer */
        '<a href="' + TRAILER_URL + '" target="_blank" rel="noopener" class="st-img-opt st-img-opt--trailer">' +
          '<span class="st-img-opt__icon">\uD83C\uDF9E\uFE0F</span>' +
          '<span class="st-img-opt__txt">' +
            '<strong>Watch the Trailer</strong>' +
            '<small>Wings of Fate official trailer</small>' +
          '</span>' +
        '</a>' +

      '</div>' +
      '<div class="st-img-popup__player" id="st-popup-player">' +
        '<audio controls preload="metadata">' +
          '<source src="' + PIANO_MP3 + '" type="audio/mpeg">' +
        '</audio>' +
        '<p>Performed by Envatilea</p>' +
      '</div>' +
    '</div>';
  document.body.appendChild(overlay);

  // ── Popup open / close ──
  function openPopup() {
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closePopup() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    var audio = overlay.querySelector('audio');
    if (audio) { audio.pause(); }
    setTimeout(function() {
      document.getElementById('st-popup-player').classList.remove('active');
    }, 300);
  }

  // Close on overlay background click
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });
  // Close button
  overlay.querySelector('.st-img-popup__close').addEventListener('click', closePopup);
  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('active')) closePopup();
  });

  // Piano option → show inline player
  document.getElementById('st-opt-piano').addEventListener('click', function (e) {
    e.preventDefault();
    var player = document.getElementById('st-popup-player');
    player.classList.add('active');
    player.querySelector('audio').play();
  });

  // ── Intercept product image clicks (desktop) ──
  function attachImageHandlers() {
    var zoomBtns = document.querySelectorAll(
      '.product-media-container__zoom-button'
    );
    var containers = document.querySelectorAll(
      '.product-media-container--image'
    );
    var slideshowSlides = document.querySelectorAll(
      'slideshow-slide[on\\:click*="zoom"]'
    );

    zoomBtns.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openPopup();
          return false;
        },
        true
      );
    });

    containers.forEach(function (container) {
      if (container.querySelector('.product-media-container__zoom-button')) return;
      container.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openPopup();
        },
        true
      );
    });

    slideshowSlides.forEach(function (slide) {
      slide.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          openPopup();
        },
        true
      );
    });

    // Add play badge to the first image container (desktop only)
    var firstContainer = document.querySelector(
      '.product-media-container--image'
    );
    if (firstContainer && !firstContainer.querySelector('.st-play-badge')) {
      firstContainer.style.position = 'relative';
      var badge = document.createElement('div');
      badge.className = 'st-play-badge';
      badge.innerHTML = '\uD83C\uDFB5 Tap to listen';
      firstContainer.appendChild(badge);
    }
  }


    // Run on DOM ready + observe for late-loading elements
  function init() {
    attachImageHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-check after delays for late-hydrating web components
  setTimeout(init, 1500);
  setTimeout(init, 3000);
})();
